<div class="container">
    <button mat-raised-button routerLink="/orders" type="button" class="back-btn">Back</button>
    <div class="header">
        <h2>View Order</h2>
    </div>
    <app-order-actions></app-order-actions>
</div>